import { render, staticRenderFns } from "./product-table-list.vue?vue&type=template&id=54210646&scoped=true"
import script from "./product-table-list.vue?vue&type=script&lang=js"
export * from "./product-table-list.vue?vue&type=script&lang=js"
import style0 from "./product-table-list.vue?vue&type=style&index=0&id=54210646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54210646",
  null
  
)

export default component.exports